<template>
  <nav class="filter">
    <button v-for="category in categories" :key="category" @click="$emit('filter', category)">
      {{ category }}
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    categories: Array
  }
};
</script>

<style scoped lang="scss">
.filter {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;

  button {
    background: linear-gradient(135deg,rgb(6, 5, 16), rgb(76, 74, 84));
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    
    &:hover {
      background: linear-gradient(135deg, #feb47b, #ff7e5f);
      transform: scale(1.05);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: scale(1.2);
      background: linear-gradient(135deg, #feb47b, #ff7e5f);
    }
  }
}
</style>
